import { Paragraph, Spinner } from '@welbe/web-design-system';
import React from 'react';
import { FiPaperclip } from 'react-icons/fi';
import {
	Container,
	ExamRow,
	ExamsContainer,
	Tooltip,
} from './DownloadOrdersButton.styles';
import {
	DownloadOrdersButtonProps,
	useDownloadOrdersButton,
} from './DownloadOrdersButton.hooks';
import { BiTaskX } from 'react-icons/bi';
import { ModalMultipleExternalOrder } from '../ModalMultipleExternalOrder/ModalMultipleExternalOrder';

export const DownloadOrdersButton = ({
	id,
	name,
	exams,
	appointmentId,
}: DownloadOrdersButtonProps) => {
	const {
		loading,
		visible,
		position,
		containerRef,
		showExternalOrderModal,
		handleHover,
		handleDownload,
		setShowExternalOrderModal,
		checkMultipleExternalOrder,
	} = useDownloadOrdersButton({ id, name, exams });

	if (!exams.length)
		return (
			<Container
				id="empty-download-order-ids"
				data-testid="empty-download-order-ids"
				cursor="not-allowed"
			>
				<BiTaskX size="18px" color="#d8dee6" />
				<Paragraph fontSize="13px" fontWeight="500" color="#d8dee6">
					No hay folios creados
				</Paragraph>
			</Container>
		);

	const groupedData = () =>
		exams.reduce((acc: any, exam: any) => {
			const existing = acc.find(
				(item: any) => item.appointmentId === exam.appointmentId,
			);

			if (existing) {
				existing.exams.push(exam.name);
			} else {
				acc.push({
					externalOrderId: exam.orderId,
					appointmentId: exam.appointmentId,
					healthCenter: exam.healthCenterName,
					exams: [exam.name],
				});
			}

			return acc;
		}, []);

	return (
		<>
			{Boolean(showExternalOrderModal) && (
				<ModalMultipleExternalOrder
					name={name}
					groupedExams={groupedData()}
					onDownload={(id) => handleDownload(id)}
					onClose={() => setShowExternalOrderModal('')}
				/>
			)}
			<Container
				ref={containerRef}
				id={`download-${id}`}
				role="button"
				cursor="pointer"
				onClick={() => {
					checkMultipleExternalOrder()
						? setShowExternalOrderModal(id)
						: !loading && handleDownload(appointmentId);
				}}
				onMouseEnter={() => handleHover(true)}
				onMouseLeave={() => handleHover(false)}
			>
				<Tooltip visible={Boolean(id && visible)} position={position}>
					<ExamsContainer>
						{exams.map((exam, index) => (
							<ExamRow key={index}>
								<span>{exam.name}</span>
								<span>{exam.orderId}</span>
							</ExamRow>
						))}
					</ExamsContainer>
				</Tooltip>
				{loading ? (
					<Spinner size="14px" />
				) : (
					<FiPaperclip
						color={id ? '#5082C2' : '#d8dee6'}
						className="order-paperclip-icon"
					/>
				)}
				<Paragraph
					fontWeight="600"
					fontSize="12"
					textDecoration="underline"
					color={id ? '#5082C2' : '#d8dee6'}
					cursor="pointer"
				>
					{id ? 'Ver folios' : 'Sin folios'}
				</Paragraph>
			</Container>
		</>
	);
};
